import type { ReactNode } from 'react';

export const AUTH_FORM_SPACING =
  'flex flex-col gap-[clamp(0.75rem,2svh,1.5rem)]';

export const AUTH_PRIMARY_BUTTON =
  'cursor-pointer bg-marketing-cta w-full text-marketing-cta-fg hover:bg-marketing-cta/90 mx-auto flex min-h-11 rounded-sm px-5 font-normal shadow-none';
export const AUTH_SECONDARY_BUTTON =
  'min-h-12 w-full cursor-pointer rounded-sm border-0 bg-marketing-mist/50 px-4 text-marketing-fg font-normal shadow-none hover:bg-marketing-mist/70';

export function AuthFormHeading({
  title,
  description,
}: {
  title: ReactNode;
  description?: ReactNode;
}) {
  return (
    <header className="mb-[clamp(1rem,4svh,3.5rem)] text-start">
      <div className="flex items-start gap-2.5 sm:gap-3 2xl:gap-4">
        <span
          aria-hidden="true"
          className="bg-marketing-purple-700 mt-[5] size-3 shrink-0 rounded-[3] font-semibold sm:mt-1.5 sm:size-4 sm:rounded 2xl:mt-2 2xl:size-6 2xl:rounded-sm"
        />
        <div>
          <h1 className="text-xl leading-tight font-semibold text-balance sm:text-2xl 2xl:text-4xl">
            {title}
          </h1>

          {description && (
            <p className="text-marketing-fg-muted mt-0.5 ml-[2] text-sm text-pretty">
              {description}
            </p>
          )}
        </div>
      </div>
    </header>
  );
}

export function AuthAlternativeActions({ children }: { children: ReactNode }) {
  return (
    <div className="mt-[clamp(0.5rem,2svh,2rem)] space-y-2">{children}</div>
  );
}

export function AuthFormError({ children }: { children: ReactNode }) {
  if (!children) return null;
  return (
    <div
      role="alert"
      className="text-destructive text-start text-sm text-pretty"
    >
      {children}
    </div>
  );
}
